import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ActivatedRoute,Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-visitor-phone',
  templateUrl: './visitor-phone.component.html',
  styleUrls: ['./visitor-phone.component.scss']
})
export class VisitorPhoneComponent implements OnInit {

  phoneNumber: string;
  constructor(public appservice:AppService,private toastr: ToastrService, public router: Router) { }


  sendOTP() {

    this.appservice.get("Api/Visitor/GenerateOTP?Phone_No=" + this.phoneNumber ).subscribe((res: any) => {
      if(res=="True")
      {
      console.log("Sending OTP to", this.phoneNumber);
      this.appservice.setItem("Phone_Number",this.phoneNumber);
      return this.router.navigate(['/visitor-otp-verification']);
      }
      else
      {
        this.toastr.error('Error ', res, {
          timeOut: 3000
        });
      }

    });

  }

  ngOnInit(): void {
    
    this.appservice.Company = "_"+this.appservice.getItem("Company");;
    
    this.appservice.get_Area_Details();
  }

}
